import React from "react";
import ReactDOM from "react-dom";
import ConfigurationPage from "./components/ConfigurationPage";

export function renderConfigurationPage() {
  ReactDOM.render(
    <ConfigurationPage />,
    document.getElementById("page-container")
  );
}

export async function displayConfigurationPage() {
  renderConfigurationPage();
}
